import { useMultiHeaderHeight } from '@/app/_shared/hooks/use-multi-header-height';

interface UseDynamicHeaderHeightResult {
  fixedHeaderRef: (el: HTMLDivElement | null) => void;
  flexibleHeaderRef: (el: HTMLDivElement | null) => void;
  headerHeight: number;
  updateHeaderHeight: () => void;
}

export const useDynamicHeaderHeight = (): UseDynamicHeaderHeightResult => {
  const fixed = useMultiHeaderHeight();
  const flexible = useMultiHeaderHeight();

  return {
    fixedHeaderRef: fixed.register,
    flexibleHeaderRef: flexible.register,
    headerHeight: fixed.totalHeight + flexible.totalHeight,
    updateHeaderHeight: () => {
      fixed.update();
      flexible.update();
    },
  };
};
